import { useGlobalData } from "@/context/global";

import Link from "next/link";
import AddIcon from "@/components/icons/AddIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import { useClient } from "@/hooks/useClient";

const Categories = ({ t, active, setActive }) => {
  const {
    appData: { megaMenuTreeData },
  } = useGlobalData();
  const { isClient } = useClient();

  return megaMenuTreeData?.length > 0 && isClient ? (
    <div className="col-span-full md:col-span-6 lg:col-span-2">
      <h2 className="hidden font-bold uppercase md:block">{t("Categories")}</h2>
      <div
        onClick={() => setActive(active === "categories" ? null : "categories")}
        className="flex items-center justify-between text-white cursor-pointer md:hidden"
      >
        <h2 className="font-bold uppercase">{t("Categories")}</h2>
        {!active || active !== "categories" ? (
          <AddIcon className="size-3" />
        ) : (
          <MinusIcon className="size-3" />
        )}
      </div>
      <ul
        className={`${
          active !== "categories" ? "hidden" : "block"
        } mt-3 md:block md:mt-6 max-sm:*:mb-3 *:mb-2 last:*:mb-0`}
      >
        {megaMenuTreeData.map((cat, idx) => (
          <li key={idx}>
            <Link prefetch={false} href={`/${cat?.url_key}`}>
              {cat.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default Categories;
